const PERMISSION_KEY = "core:api_key_permission_group_mapping";
const PAGE_URL = {
    API_KEY_PERMISSION_GROUP_MAPPING_PAGE: "/admin/core/api-key-permission-group-mapping"
}

export { PERMISSION_KEY, PAGE_URL }
